import { Route, Routes } from "react-router-dom";
import ReportList from "../../components/report-list/report-list.component";
import ReportDetails from "../../components/report-details/report-details.component";

const ReportNavigation = () => {
  return (
    <Routes>
      <Route index element={<ReportList />} />
      <Route path="reportDetail/:reportId" element={<ReportDetails />} />
    </Routes>
  );
};

export default ReportNavigation;
